import type { z } from 'zod';
import type { ApiContract } from '@responsedock/api-contracts';
import { api } from './api';

export async function callApiContract<
  TContract extends ApiContract<'GET' | 'POST', string, z.ZodTypeAny | undefined, z.ZodTypeAny>,
>(
  definition: TContract,
  input?: TContract['request'] extends z.ZodTypeAny ? z.input<TContract['request']> : never,
): Promise<z.output<TContract['response']>> {
  const data = definition.request ? definition.request.parse(input) : undefined;
  const response = await api.request<unknown>({
    method: definition.method,
    url: definition.path,
    data,
  });
  return definition.response.parse(response.data) as z.output<TContract['response']>;
}
